module.exports = __webpack_public_path__ + "img/row1-bg.5cd3d587.png";